import { cn } from '@/lib/cn'
import styles from './Meter.module.css'

export function Meter({
  value,
  height = 8,
  tone = 'accent',
  onDark = false,
  label,
  className,
}: {
  /** 0–1. Clamped. */
  readonly value: number
  readonly height?: number | undefined
  readonly tone?: 'accent' | 'ink' | undefined
  readonly onDark?: boolean | undefined
  readonly label?: string | undefined
  readonly className?: string | undefined
}) {
  const pct = Math.max(0, Math.min(1, value))
  return (
    <div
      className={cn(styles.track, onDark && styles.onDark, className)}
      style={{ height }}
      role="meter"
      aria-valuenow={Math.round(pct * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div
        className={cn(styles.fill, tone === 'ink' && styles.inkFill)}
        style={{ width: `${pct * 100}%` }}
      />
    </div>
  )
}
